import { useEffect, useState } from "react";

export default function DynamicSelect({
                                          storageKey,
                                          idKey,
                                          labelKey,
                                          name,          // ✅ IMPORTANT
                                          value,
                                          onChange,
                                          placeholder = "Choisir",
                                          style = {},
                                          disabled = false,
                                          options: optionsProp, // ✅ liste explicite fournie par le parent (prioritaire sur localStorage[storageKey])
                                      }) {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (optionsProp) return; // liste déjà fournie par le parent : pas de lecture localStorage
        const data = localStorage.getItem(storageKey);

        if (data) {
            try {
                setOptions(JSON.parse(data));
            } catch (e) {
                console.error("Erreur parsing localStorage", e);
            }
        }
    }, [storageKey, optionsProp]);
    const finalOptions = optionsProp || options;
    const finalName = name || idKey;
    return (
        <select
            name={finalName} // ✅ AJOUT IMPORTANT
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            className="ft-select-arrow"
            style={style}
            disabled={disabled}
        >
            <option value="">{placeholder}</option>

            {finalOptions.map((item) => (
                <option key={item[idKey]} value={item[idKey]}>
                    {item[labelKey]}
                </option>
            ))}
        </select>
    );
}